import { Injectable } from '@angular/core';
import { ApiService } from "../api-service/api-service";


@Injectable()
export class ArticleService {

  constructor(public apiSer: ApiService) {

  }

  // 资讯首页
  articleHome(params?: any) {
    let seq = this.apiSer.get('v1/article/home', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });

    return seq;
  }

  // 文章详情
  articleDetails(params?: any) {
    let seq = this.apiSer.get('v1/article/show', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });

    return seq;
  }

  // 文章点赞
  articleLike(params?: any) {
    let seq = this.apiSer.get('v1/article/like', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });

    return seq;
  }

  // 搜藏
  articleFavorite(params?: any) {
    let seq = this.apiSer.get('v1/article/favorite', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });

    return seq;
  }

  // 分享
  articleShare(params?: any) {
    let seq = this.apiSer.get('v1/article/share', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });

    return seq;
  }

  // 文章评论
  articleComments(params?: any) {
    let seq = this.apiSer.get('v1/article/comment', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });

    return seq;
  }

  articleCommentPost(params?: any) {

    let seq = this.apiSer.post('v1/article/comment', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });

    return seq;
  }

  articleCommentReply(params?: any) {

    let seq = this.apiSer.post('v1/article/comment/reply', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });

    return seq;
  }

  articleCommentDelete(params?: any) {
    let seq = this.apiSer.get('v1/article/comment/delete', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });

    return seq;
  }

  articleCommentLike(params?: any) {
    let seq = this.apiSer.get('v1/article/comment/like', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });

    return seq;
  }
}



// WEBPACK FOOTER //
// ./src/providers/data-service/article-service.ts